import { Component, Input } from '@angular/core';

export interface IPushPicture {
  heading: string;
  buttonLabel?: string;
  buttonLink?: string;
  imgUrl?: string;
  backgroundColor?: string;
}

@Component({
  selector: 'app-push-picture-atom',
  templateUrl: './push-picture-atom.component.html',
  styleUrls: ['./push-picture-atom.component.scss'],
})
export class PushPictureAtomComponent {
  @Input() heading!: string;
  @Input() buttonLabel!: string;
  @Input() buttonLink!: string;
  @Input() pictureUrl!: string;
  @Input() backgroundColor!: string;
}
